import { CircularProgress } from '@mui/material';


// 自定义页面loading
export function CustomerLoading(): JSX.Element {
    // *********************
    // View
    // *********************

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f1f4f870',
                zIndex: 9999
            }}>
            <CircularProgress />
        </div >
    )
}